import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-help-import-members',
  templateUrl: './help-import-members.component.html',
  styleUrls: ['./help-import-members.component.scss']
})
export class HelpImportMembersComponent
{
  @Input() public patientLabel: string;
  @Input() public language: string;

  public sampleFileUrl = 'assets/files/members.csv';
  public document360Url = 'https://channels360.document360.io/docs/client-import-guide';
}
